<template>
  <el-tree
    ref="tree"
    :data="treeData"
    :node-key="nodeKey"
    show-checkbox
    expand-on-click-node
    :default-checked-keys="defaultCheckedKeys"
    :default-expand-all="expandAll"
    highlight-current
    :props="defaultProps"
    @check="getKeys"
  >
    <span
      slot-scope="{ node }"
      class="custom-tree-node">
      <span>{{ node.label }}</span>
    </span>
  </el-tree>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'CheckboxTree',
  components: {},
  props: {
    expandAll: {
      type: Boolean,
      default: true
    },
    treeData: {
      type: Array,
      default() {
        return []
      }
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'label'
        }
      }
    }
  },
  data() {
    return {

    }
  },
  computed: {
    defaultCheckedKeys: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    disabled() {
      return this.defaultCheckedKeys.indexOf(135) === -1
    },
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },

  methods: {
    getKeys(data, checked) {
      console.log('getKeys--------------------')
      this.defaultCheckedKeys = checked.checkedKeys
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes()
    }
  }
}
</script>
<style lang="stylus">
.custom-tree-node {
   flex: 1;
   display: flex;
   align-items: center;
   justify-content: space-between;
   font-size: 14px;
   padding-right: 8px;
 }
</style>
